<template>
  <div class="auth_page">
    <div class="auth_logo">
      <img :src="merchantInfo.merchantLogo" :alt="merchantInfo.merchantName" referrerpolicy="no-referrer" />
    </div>
    <div class="auth_desc" :class="[$store.state.isMirroring && 'mirror']">
      <i18n path="authorize.requirement" tag="span">
        <span class="auth_merchant_name">{{ merchantInfo.merchantName }}</span>
        <span v-if="isLogin">
          &nbsp;({{ $t('account.account') }}: <span style="direction: ltr">{{ formatAccount(account) }}</span
          >)
        </span>
      </i18n>
    </div>
    <!-- 登录展示授权按钮 -->
    <van-button v-if="isLogin" :disabled="disabledAuth" class="auth_btn" @click="authorize" :loading="loading">
      {{ $t('authorize.authorize') }}
    </van-button>
    <div v-if="showSwitchAccountBtn" class="auth_text" @click="switchAccount">
      {{ $t('authorize.switchAccount') }}
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'
import CheckBox from '@/components/CheckBox'
export default {
  name: 'QuickLoginAuth',
  data() {
    return {
      url: window.location.href,
      merchantInfo: {
        merchantName: '',
        merchantLogo: ''
      },
      loading: false,
      agreeQuickLogin: true,
      showSwitchAccountBtn: false,
      disabledAuth: false
    }
  },
  components: {
    CheckBox
  },
  created() {
    this.checkToLogined()
  },
  computed: {
    // 判断是否登录，有用户信息且 login 还有
    isLogin() {
      return (
        this.$store.state.userInfo &&
        this.$store.state.userInfo.hasOwnProperty('userId') &&
        localStorage.getItem('token')
      )
    },
    // 账号信息
    account() {
      if (this.$store.state.userInfo.phone) {
        return this.$store.state.userInfo.phone ? '+' + this.$store.state.userInfo.phone : ''
      } else {
        return this.$store.state.userInfo.email
      }
    }
  },
  methods: {
    switchAccount() {
      // 清空登录态，重新登录
      this.$store.commit('clearState')
      localStorage.removeItem('token')
      localStorage.removeItem('store')
      // 记录当前的 url 参数，跳转到登录页面
      this.$store.commit('setQuickLoginAuthInfo', {
        ...this.$route.query
      })
      this.$router.replace({
        name: 'beforeLogin'
      })
    },
    // 获取商户信息
    getMerchantInfo() {
      this.$store.commit('delQuickLoginAuthInfo')
      // appId，uid 做关联授权关系建立，如果数据不全，重定向到首页
      if (
        this.$route.query.hasOwnProperty('appId') &&
        this.$route.query.hasOwnProperty('redirectUrl') &&
        this.$route.query.hasOwnProperty('uid')
      ) {
        const appId = this.$route.query.appId
        const urlParams = new URLSearchParams(new URL(window.location.href).search)
        const apptype = urlParams.get('apptype')
        let url = window.serverPath + `/api/merchant/info?appId=${appId}&apptype=${apptype}`
        if (apptype && apptype === '37') {
          // 针对 And 包，做特殊的逻辑处理，公用一个应用id
          url = url + '&type=1'
        } else {
          url = url + '&type=0'
        }
        this.$http
          .get(url)
          .then((res) => {
            if (res.data && res.data.code === '200') {
              this.merchantInfo = res.data.data
            }
          })
          .catch((err) => console.log(err))
      } else {
        this.$router.push({
          name: 'Home'
        })
      }
    },
    authorize() {
      // 判断授权，授权成功，服务端返回认证 code，重定向到redirect_url?code=CODE
      if (
        this.$route.query.hasOwnProperty('appId') &&
        this.$route.query.hasOwnProperty('redirectUrl') &&
        this.$route.query.hasOwnProperty('uid') &&
        this.$route.query.hasOwnProperty('openId')
      ) {
        this.loading = true
        const appId = this.$route.query.appId
        const apptype = this.$route.query.apptype
        const redirectUrl = this.$route.query.redirectUrl
        const uid = encodeURIComponent(this.$route.query.uid)
        const openId = this.$route.query.openId
        this.$http
          .get(
            window.serverPath +
              '/api/auth/quickLogin/authorize?appId=' +
              appId +
              `&uid=${uid}` +
              `&openId=${openId}` +
              '&redirectUrl=' +
              redirectUrl
          )
          .then((res) => {
            if (res.data && res.data.code === '200') {
              const code = res.data.data.code
              const query = { ...this.$route.query }
              delete query.appId
              delete query.redirectUrl
              query.code = code
              this.$store.commit('delQuickLoginAuthInfo')
              let queryStr = ''
              for (let key in query) {
                queryStr += key + '=' + query[key] + '&'
              }
              queryStr = queryStr.substr(0, queryStr.length - 1)
              if (apptype === '36') {
                this.$http.get(redirectUrl + '?' + queryStr).then(() => {
                  window.close()
                })
              } else {
                window.location.href = redirectUrl + '?' + queryStr
              }
            } else if (res.data.code === '100017') {
              this.loading = false
              this.showSwitchAccountBtn = true
              this.disabledAuth = true
              // 账号不匹配，重新登录
              this.$store.commit('delQuickLoginAuthInfo')
              Toast({
                message: this.$t('authorize.notMatchTips')
              })
            }
            setTimeout(() => {
              this.loading = false
            }, 30000)
          })
          .catch((err) => {
            console.log(err)
            setTimeout(() => {
              this.loading = false
            }, 30000)
          })
      } else {
        console.log('err')
      }
    },
    // 账号脱敏，登录情况下
    formatAccount(account) {
      if (account) {
        const len = account.length
        if (len > 10) {
          return account.substr(0, 6) + '****' + account.substr(len - 4, len)
        } else if (len > 6) {
          return account.substr(0, 4) + '***' + account.substr(len - 2, len)
        }
        return account
      }
      return account
    },
    // 检查是否跳转登录过
    checkToLogined() {
      // const loginFlag = window.localStorage.getItem("to_logined")
      // 当前是登录状态，且 toLogined
      let toLogined = this.$route.query.hasLogined || 0
      if (this.isLogin && toLogined) {
        this.getMerchantInfo()
      } else {
        // 清空登录态，重新登录
        this.$store.commit('clearState')
        localStorage.removeItem('token')
        localStorage.removeItem('store')
        // 记录当前的 url 参数，跳转到登录页面
        this.$store.commit('setQuickLoginAuthInfo', {
          ...this.$route.query
        })
        this.$router.replace({
          name: 'beforeLogin'
        })
      }
    }
  }
}
</script>

<style scoped>
.auth_page {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 0.24rem;
}

.check_login {
  margin-top: 0.03rem;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  color: #443956;
  font-family: 'PingFang SC';
  font-size: 0.12rem;
  font-style: normal;
  font-weight: 400;
  line-height: 0.2rem;
}

.auth_logo {
  width: 0.8rem;
  height: 0.8rem;
  overflow: hidden;
  margin: 1rem 0.24rem 0.24rem;
  font-size: 0.24rem;
  line-height: 0.8rem;
}

.auth_logo img {
  max-width: 100%;
  max-height: 100%;
  object-fit: cover;
  user-select: none;
}

.auth_desc {
  font-size: 0.14rem;
  text-align: left;
  line-height: 0.2rem;
  word-break: break-word;

  &.mirror {
    text-align: right;
  }
}

.auth_merchant_name {
  color: #378e5b;
}

.auth_btn {
  height: 0.5rem;
  padding: 0.13rem 0;
  font-size: 0.18rem;
  font-weight: bold;
  background: #378e5b;
  margin: 0.3rem 0 0;
  width: 100%;
  border-radius: 0.12rem;
  line-height: 0.24rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  user-select: none;
}

.auth_text {
  height: 0.5rem;
  font-size: 0.16rem;
  font-weight: bold;
  margin: 0.12rem 0 0.24rem;
  width: 100%;
  border-radius: 0.12rem;
  border: 1px solid #378e5b;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #378e5b;
  user-select: none;
}

.auth_to_login {
  height: 0.42rem;
  font-size: 0.18rem;
  font-weight: bold;
  width: 100%;
  border-radius: 0.06rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #378e5b;
  border: 2px solid #378e5b;
  user-select: none;
  margin: 0.3rem 0 0.24rem;
}

.auth_to_register {
  height: 0.42rem;
  font-size: 0.18rem;
  font-weight: bold;
  width: 100%;
  border-radius: 0.06rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #378e5b;
  border: 2px solid #378e5b;
  user-select: none;
  margin: 0.3rem 0 0.24rem;
}
</style>



// WEBPACK FOOTER //
// src/views/QuickLoginAuth.vue